import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

const ComplianceCoverageLegend = () => (
  <Root>
    <Item>
      <Swatch data-status="uploaded" />
      <FormattedMessage
        id="complianceCoverage.legend.uploaded"
        defaultMessage="✓ uploaded — codes show which languages are in"
      />
    </Item>
    <Item>
      <Swatch data-status="missing" />
      <FormattedMessage
        id="complianceCoverage.legend.missing"
        defaultMessage="✕ certified, nothing uploaded"
      />
    </Item>
    <Item>
      <Swatch data-status="not_applicable" />
      <FormattedMessage
        id="complianceCoverage.legend.notApplicable"
        defaultMessage="— not certified for this market"
      />
    </Item>
  </Root>
);

const Root = styled('div')(({ theme }) => ({
  flexShrink: 0,
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1, 3),
  padding: theme.spacing(1.5, 2.25),
  fontSize: 13,
  color: theme.palette.textSecondaryDarkGrey,
  borderTop: `1px solid ${theme.palette.grey200}`,
}));

const Item = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
});

const Swatch = styled('span')(({ theme }) => ({
  width: 14,
  height: 14,
  marginRight: 6,
  borderRadius: 3,
  border: `1px solid ${theme.palette.grey200}`,

  '&[data-status="uploaded"]': {
    background: theme.palette.green50,
  },
  '&[data-status="missing"]': {
    background: theme.palette.red50,
  },
  '&[data-status="not_applicable"]': {
    background: theme.palette.grey50,
  },
}));

export default ComplianceCoverageLegend;
